export default __webpack_public_path__ + "i18n/translations/translation-id.df21dd00.json";